'use client'

import * as React from 'react'

/**
 * Whether an `<img>` failed to load, including a failure that happened before
 * hydration attached `onError` (the server-rendered image had already given
 * up): on mount, `decode()` rejects for a broken image and resolves for one
 * that loads. Resets when the source changes.
 */
export function useImageFailed(src: string | null | undefined) {
  const [img, setImg] = React.useState<HTMLImageElement | null>(null)
  const [failedSrc, setFailedSrc] = React.useState<string | null>(null)
  React.useEffect(() => {
    if (!img || !src || typeof img.decode !== 'function') return
    let live = true
    img.decode().catch(() => {
      if (live && img.complete && img.naturalWidth === 0) setFailedSrc(src)
    })
    return () => {
      live = false
    }
  }, [img, src])
  return {
    attach: setImg,
    failed: !!src && failedSrc === src,
    onError: () => setFailedSrc(src ?? null),
  }
}
